import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../../../../../../components/loan_application/form_models/constants';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { PowerTaxEquityPartneringRuleset } from '../../business/ruleset';
import { RulesetResult } from '../../business/rules';

const {
  formField: { systemPowerTaxEquityPartnering },
} = loanFormModel;

export class PowerTaxEquityPartneringValidation implements ValidationSchema {
  public name: string = systemPowerTaxEquityPartnering.name;
  public label: string = systemPowerTaxEquityPartnering.getLabel(
    defaultBorrowerLegalName
  );

  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = PowerTaxEquityPartneringRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new PowerTaxEquityPartneringValidation());
